import type { IconSvgObject } from './types';

const DropletIcon: IconSvgObject = [
  ["path", { d: "M11.4346 2.42125C9.53491 3.88072 3.5 8.89368 3.5 13.678C3.5 17.7804 6.71878 22 12 22C17.2812 22 20.5 17.7804 20.5 13.678C20.5 8.89368 14.4651 3.88072 12.5654 2.42125C12.2298 2.16343 11.7702 2.16343 11.4346 2.42125Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16 14C16 16.2091 14.2091 18 12 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default DropletIcon;
